// extracted by mini-css-extract-plugin
module.exports = {"orgSwitch":"zXwr9Sjx","collapsed":"__6v1_r9Lf","content":"_dBFwR4U","arrow":"C6T1QpRg","active":"hPTL_AbJ","title":"I_aLRcM4","description":"VwDOezWN","dropdownContent":"csqsO6jk"};